var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"replenishment"},[_c(_vm.getComponent,{tag:"component",attrs:{"index":_vm.replenishmentType[_vm.current].toIndex,"customer-code":_vm.customerCode},on:{"changeType":_vm.changeType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }